/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import UMA from 'views/CatalogosDeRecaudacion/UMA';
import CPP from 'views/CatalogosDeRecaudacion/CPP';
import FundamentosLegales from 'views/CatalogosDeRecaudacion/FundamentosLegales';
import Bancos from 'views/CatalogosDeRecaudacion/Bancos';
import CanalDePago from 'views/CatalogosDeRecaudacion/CanalDePago';
import FormatoDeFolios from 'views/CatalogosDeRecaudacion/Foliador';
import Fuentes from 'views/CatalogosDeRecaudacion/Fuentes';
import INPC from 'views/CatalogosDeRecaudacion/INPC';
import Monedas from 'views/CatalogosDeRecaudacion/Monedas';
import Periodos from 'views/CatalogosDeRecaudacion/Periodos';
import TipoDePago from 'views/CatalogosDeRecaudacion/TipoDePago';
import UnidadesRecaudadoras from 'views/CatalogosDeRecaudacion/UnidadesRecaudadoras';
import TipoDeConsiderado from 'views/CatalogosDeRecaudacion/TipoDeConsiderado';
// import DeterminablesPorPadron from 'views/Recaudacion/DeterminablesPorPadron';
// import DeterminablesPorTipoDeCargo from 'views/Recaudacion/DeterminablesPorTipoDeCargo';
import Sistemas from 'views/CatalogosDeRecaudacion/Sistemas';
import SubunidadesRecaudadoras from 'views/CatalogosDeRecaudacion/SubUnidadesDeRecaudacion';
import MotivosDeReintegro from 'views/CatalogosDeRecaudacion/MotivosDeReintegro';
// import Reportes from 'views/CatalogosDeRecaudacion/Reportes';
// import DeterminablesPorPadrones from 'views/Recaudacion/DeterminablesPorPadrones';

export default
{
  title: 'Catálogos de Recaudación',
  icon: () => <UnorderedListOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Unidad de Medida y Actualización',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: UMA,
      permissionModel: 'uma',
    },
    {
      title: 'Tabulador de Factores de Cobro INPC',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: INPC,
      permissionModel: 'inpc',
    },
    {
      title: 'Costo Porcentual Promedio CPP',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CPP,
      permissionModel: 'cpp',
      tags: ['cpp'],
    },

    {
      title: 'Periodos de Pago',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Periodos,
      permissionModel: 'periodo',
    },
    {
      title: 'Fundamentos Legales',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: FundamentosLegales,
      permissionModel: 'fundamentolegal',
    },
    {
      title: 'Unidades Recaudadoras',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: UnidadesRecaudadoras,
      permissionModel: 'unidadderecaudacion',
      catalogsModels: ['unidadresponsable', 'usuario', 'conceptodeingreso'],
    },
    {
      title: 'Subunidades Recaudadoras',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: SubunidadesRecaudadoras,
      permissionModel: 'subunidadderecaudacion',
      catalogsModels: ['unidadderecaudacion'],
    },
    {
      title: 'Motivos de Reintegro',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: MotivosDeReintegro,
      permissionModel: 'motivodereintegro',
    },
    {
      title: 'Fuentes de Ingresos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Fuentes,
      permissionModel: 'clasificaciondefuentedefinanciamiento',
    },
    {
      title: 'Canal de Pago',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CanalDePago,
      permissionModel: 'canaldepago',
    },
    {
      title: 'Tipos de Pago',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TipoDePago,
      permissionModel: 'tipodepago',
      catalogsModels: ['cuentadebanco'],
    },
    {
      title: 'Tipos de Considerado',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TipoDeConsiderado,
      permissionModel: 'tipodeconsiderado',
    },
    {
      title: 'Monedas',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Monedas,
      permissionModel: 'moneda',
    },
    {
      title: 'Bancos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Bancos,
      permissionModel: 'banco',
    },
    {
      title: 'Formato de Folios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: FormatoDeFolios,
      permissionModel: 'configuraciondesegmentofolio',
      catalogsModels: ['segmentodefolio'],
      tags: ['foliadores'],
    },
    // {
    //   title: 'Generar Determinables por Tipo de Padrón',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: DeterminablesPorPadron,
    //   permissionModel: 'cargo',
    // },
    // {
    //   title: 'Generar Determinables por Tipo de Cargo',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: DeterminablesPorTipoDeCargo,
    //   permissionModel: 'cargo',
    // },
    {
      title: 'Sistemas',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Sistemas,
      permissionModel: 'sistemas',
    },
  ],
};
